import React, { ChangeEvent } from 'react'
import ModalSelectScheduleNotification from './ModalSelectScheduleNotification/ModalSelectScheduleNotification'
import { DeviceNotification, FrecuencyNotification, FrecuencyNotificationId, ScheduleFrecuency, SubjectNotification, TopicNotification } from '../CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import { Schedule } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import ModalResumeScheduleNotification from './ModalResumeScheduleNotification/ModalResumeScheduleNotification'

type ConModalSelectScheduleNotificationProps = {
    frecuency: FrecuencyNotification
    subject: SubjectNotification
    topic: TopicNotification
    device: DeviceNotification
    schedule: ScheduleFrecuency
    title: string
    bodyNotif: string
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ConModalSelectScheduleNotification = ({
    frecuency,
    subject,
    topic,
    device,
    schedule,
    title,
    bodyNotif,
    onSubmit,
    onCloseModal,
}: ConModalSelectScheduleNotificationProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalResumeScheduleNotification
                                onCloseModal={onCloseModal}
                                frecuency={frecuency}
                                subject={subject}
                                topic={topic}
                                device={device}
                                schedule={schedule}
                                title={title}
                                bodyNotif={bodyNotif}
                                onSubmit={onSubmit}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalSelectScheduleNotification )